/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentWithRelations } from './assessmentWithRelations';
import { QuestionWithRelations } from './questionWithRelations';


/**
 * (tsType: AssessmentSectionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface AssessmentSectionWithRelations { 
    id?: string;
    title: string;
    description?: string;
    orderIndex: number;
    isRequired: boolean;
    assessmentId: string;
    assessment?: AssessmentWithRelations;
    questions?: Array<QuestionWithRelations>;
}

